<template>
  <fn-add-to-cart-form
    :badges="product.badges"
    :variant-selectors="product.variantSelectors"
    :pricing="product.pricing"
    :stock="product.stock"
    :code="product.code"
    :url="product.url"
    :minimal="minimal"
    :max-quantity="product.maxOrderQuantity"
    :shipping-information="showShippingInformation && product.shippingInformation"
    :marketplace-article="product.marketplaceArticle"
    :click-and-collect-article="product.availableForClickAndCollect"
    :has-size-tables-or-measure-info="hasSizeTablesOrMeasureInfo"
    @change-variant="(payload) => $emit('changeVariant', payload)"
    @add-to-cart-overlay="(payload) => $emit('addToCartOverlay', payload)"
    @change-tab="(tab) => $emit('changeTab', tab)"
    @modal-sizes-and-measurements-opened="$emit('modalSizesAndMeasurementsOpened')"
  />
</template>

<script setup>
defineEmits(['changeVariant', 'addToCartOverlay', 'changeTab', 'modalSizesAndMeasurementsOpened']);
defineProps({
  product: {
    type: Object,
    required: true,
  },
  minimal: {
    type: Boolean,
  },
  showShippingInformation: {
    type: Boolean,
  },
  hasSizeTablesOrMeasureInfo: {
    type: Boolean,
  },
});
</script>
